// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__nnpi3","header":"ReportDetails_header__2HKmc","title":"ReportDetails_title__r17md","left":"ReportDetails_left__2tdhD"};